enum EquipmentSettings {
	isEquipmentAutomaticReturnDate = 'Equipment status automatic return date',
}

export enum EquipmentSettingsHint {
	isEquipmentAutomaticReturnDate = 'Equipment status will automatically return to previous available status upon return date expiration.',
}

export default EquipmentSettings;
